export default "__VITE_ASSET__Cy6wmh29__"